import { render } from "./verifyDealerForm.vue?vue&type=template&id=0a33638a&scoped=true"
import script from "./verifyDealerForm.vue?vue&type=script&lang=js"
export * from "./verifyDealerForm.vue?vue&type=script&lang=js"

import "./verifyDealerForm.vue?vue&type=style&index=0&id=0a33638a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a33638a"]])

export default __exports__